import { FC } from 'react'

import { clsx } from 'clsx'

import type { HelperTextProps } from '../HelperText/HelperText.js'

export const HelperText: FC<HelperTextProps> = props => {
  const { invalid = false, children, className } = props

  return (
    <p
      className={clsx(
        'text-sm first-letter:capitalize',
        !invalid && 'text-content-subdued',
        invalid && 'text-action-destructive',
        className,
      )}
    >
      {children}
    </p>
  )
}
